// Progress — thin determinate bar. `value` is clamped against `max`.
// Intent recolors the fill (e.g. danger for over-budget).

import { forwardRef, type HTMLAttributes } from 'react';

export type ProgressVariant = 'brand' | 'success' | 'warning' | 'danger';

export interface ProgressProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  /** Current value. */
  value: number;
  /** Maximum value. Default 100. */
  max?: number;
  variant?: ProgressVariant;
}

const Progress = forwardRef<HTMLDivElement, ProgressProps>(function Progress(
  { value, max = 100, variant = 'brand', className = '', ...rest },
  ref,
) {
  const pct = max <= 0 ? 0 : Math.min(100, Math.max(0, (value / max) * 100));
  const classes = ['app-progress', `app-progress--${variant}`, className].filter(Boolean).join(' ');

  return (
    <div
      ref={ref}
      className={classes}
      role='progressbar'
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      {...rest}
    >
      <i className='app-progress__bar' style={{ width: `${pct}%` }} />
    </div>
  );
});

export default Progress;
